module.exports = "<input type=\"text\" [(ngModel)]=\"value\" class=\"form-control\" [disabled]=\"!editing\" (keydown)=\"onKeyDown($event)\">\n\n<span class=\"edit\" (click)=\"edit()\" *ngIf=\"!editing\"><i class=\"material-icons\">edit</i></span>\n<span class=\"cancel\" (click)=\"cancel()\" *ngIf=\"editing\"><i class=\"material-icons\">undo</i></span>\n<span class=\"save\" (click)=\"save()\" *ngIf=\"editing\"><i class=\"material-icons\">save</i></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input-edit-field/input-edit-field.component.html
// module id = ./src/app/shared/input-edit-field/input-edit-field.component.html
// module chunks = main